import BaseError from "./BaseError";

export default class UnauthorizedError extends BaseError {
  constructor(message: string, info?: any, cause?: Error) {
    super({
      statusCode: 401,
      message,
      info: info || null,
      cause,
    });
    this.name = "UnauthorizedError";
  }
}
